export const isSamePreferredCurrency = (shipments: {preferred_currency?: 'CAD' | 'CNY' | 'EUR' | 'MXN' | 'USD'}[]) =>
  shipments?.every((shipment) => shipment.preferred_currency === shipments?.[0]?.preferred_currency);
